import { render, staticRenderFns } from "./AppRadio.vue?vue&type=template&id=2fc5b0bd&scoped=true&"
import script from "./AppRadio.vue?vue&type=script&lang=js&"
export * from "./AppRadio.vue?vue&type=script&lang=js&"
import style0 from "./AppRadio.vue?vue&type=style&index=0&id=2fc5b0bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc5b0bd",
  null
  
)

export default component.exports